import { Suspense } from 'react';

import { variationMapper } from './variations-mapper';

import type { ButtonVariations } from './Button.d';
import type { DownloadContentProps } from './variants';

export const Button = ({
  variation,
  variantProps,
}: {
  variation: ButtonVariations;
  variantProps: DownloadContentProps;
}) => {
  const Component = variationMapper[variation];

  return (
    <Suspense fallback={<div />}>
      <Component {...variantProps} />
    </Suspense>
  );
};
